/**
 * The project's types for the editor's placed-view slash entries ("Table:
 * Competitors", "2x2: Competitors"). `PagesTrackersProvider` feeds it from the
 * tracker room's schema; each editor mount in Pages reads it, so a mount made
 * before the room opened offers the types once it does. Listed as the
 * desktop's `globalRegistry.getListed()`: a type hidden until another exists
 * appears once that one does.
 */
import type { PlacedViewTypeOption, PlacedViewTypeSource } from '@nimbalyst/collab-bundle/editor';

type TypeModel = PlacedViewTypeOption & { hiddenUntilType?: string };

export interface PlacedViewTypeStore extends PlacedViewTypeSource {
  set(models: readonly TypeModel[]): void;
}

export function createPlacedViewTypeStore(): PlacedViewTypeStore {
  let listed: readonly PlacedViewTypeOption[] = [];
  const listeners = new Set<() => void>();
  return {
    list: () => listed,
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    set(models) {
      const present = new Set(models.map((model) => model.type));
      listed = models.filter((model) => !model.hiddenUntilType || present.has(model.hiddenUntilType));
      for (const listener of [...listeners]) listener();
    },
  };
}

/** The one store the console's Pages editors read. */
export const pagesPlacedViewTypes = createPlacedViewTypeStore();
